module.exports = window.listLimitsPowerUpId



// WEBPACK FOOTER //
// ./app/scripts/data/list-limits-power-up-id.coffee